import CryptoJS from "crypto-js"

export function cryptString($str) {
  return CryptoJS.AES.encrypt(
    $str,
    CryptoJS.enc.Utf8.parse(process.env.VUE_APP_CRYPT_KEY),
    {
      iv: CryptoJS.enc.Utf8.parse(process.env.VUE_APP_CRYPT_IV),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    },
  ).toString()
}

export function decryptString($str) {
  return CryptoJS.AES.decrypt(
    $str,
    CryptoJS.enc.Utf8.parse(process.env.VUE_APP_CRYPT_KEY),
    {
      iv: CryptoJS.enc.Utf8.parse(process.env.VUE_APP_CRYPT_IV),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    },
  ).toString(CryptoJS.enc.Utf8)
}